import { useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async'; // react-helmet-async를 사용하여 SEO 메타 태그 관리

interface StaticHtmlProps {
  number: number; // ex: 1 → 1.html
}

type Post = {
  rank: number;
  title: string;
  channel: string;
  description: string;
  thumbnail: string;
  rankChange: number;
};

const posts: Record<number, Post> = {
    1: {rank: 1, title: '부모의 역할이 바꾸는 아이의 공부 습관 – 초중고 학습을 위한 실천 전략', channel: 'ch1', description: '부모의 역할이 바꾸는 아이의 공부 습관 – 초중고 학습을 위한 실천 전략', thumbnail: 'https://via.placeholder.com/80x80?text=1', rankChange: 1}, 
    2: {rank: 2, title: '초등학생 공부 습관, 이렇게 기르세요!', channel: 'ch1', description: '초등학생 공부 습관, 이렇게 기르세요!', thumbnail: 'https://via.placeholder.com/80x80?text=2', rankChange: -1}, 
    3: {rank: 3, title: '성적 올리는 중학생 공부법 BEST 5 – 부모가 꼭 알아야 할 실전 팁!', channel: 'ch1', description: '성적 올리는 중학생 공부법 BEST 5 – 부모가 꼭 알아야 할 실전 팁!', thumbnail: 'https://via.placeholder.com/80x80?text=3', rankChange: 0}, 
    4: {rank: 4, title: '고등학생 자기주도학습 비결 🔥 성공하는 공부 습관 만들기 전략', channel: 'ch1', description: '고등학생 자기주도학습 비결 🔥 성공하는 공부 습관 만들기 전략', thumbnail: 'https://via.placeholder.com/80x80?text=4', rankChange: 2}, 
    5: {rank: 5, title: '자기주도학습이 성공을 결정짓는 이유! 우리 아이 공부법의 핵심 전략', channel: 'ch1', description: '자기주도학습이 성공을 결정짓는 이유! 우리 아이 공부법의 핵심 전략', thumbnail: 'https://via.placeholder.com/80x80?text=5', rankChange: -2}, 
    6: {rank: 6, title: '아이 집중력 키우는 부모의 전략, 이렇게 실천해보세요!', channel: 'ch1', description: '아이 집중력 키우는 부모의 전략, 이렇게 실천해보세요!', thumbnail: 'https://via.placeholder.com/80x80?text=6', rankChange: 0}, 
    7: {rank: 7, title: '공부 잘하는 아이들, 이렇게 다릅니다! 부모가 알아야 할 7가지 특징', channel: 'ch1', description: '공부 잘하는 아이들, 이렇게 다릅니다! 부모가 알아야 할 7가지 특징', thumbnail: 'https://via.placeholder.com/80x80?text=7', rankChange: 1}, 
    8: {rank: 8, title: '뇌과학이 밝힌 초집중 학습법: 기억력과 이해력을 높이는 뇌 활용 전략', channel: 'ch1', description: '뇌과학이 밝힌 초집중 학습법: 기억력과 이해력을 높이는 뇌 활용 전략', thumbnail: 'https://via.placeholder.com/80x80?text=8', rankChange: -1}, 
    9: {rank: 9, title: '아침 공부가 성적을 바꾼다? 과학적 근거와 실천 전략',  channel: 'ch1', description: '아침 공부가 성적을 바꾼다? 과학적 근거와 실천 전략', thumbnail: 'https://via.placeholder.com/80x80?text=9', rankChange: 0},     
    10: {rank: 10, title: '공부 시간 관리의 기술, 성적 향상의 첫걸음!', channel: 'ch1', description: '공부 시간 관리의 기술, 성적 향상의 첫걸음!', thumbnail: 'https://via.placeholder.com/80x80?text=10', rankChange: 1}, 
    11: {rank: 11, title: '하루를 바꾸는 공부 계획 세우기 전략', channel: 'ch1', description: '하루를 바꾸는 공부 계획 세우기 전략', thumbnail: 'https://via.placeholder.com/80x80?text=11', rankChange: 0},
    12: {rank: 12, title: '공부 안 하는 아이, 부모는 어떻게 도와줘야 할까?', channel: 'ch1', description: '공부 안 하는 아이, 부모는 어떻게 도와줘야 할까?', thumbnail: 'https://via.placeholder.com/80x80?text=12', rankChange: 0},
    13: {rank: 13, title: '공부를 싫어하는 아이, 부모가 꼭 알아야 할 해결법', channel: 'ch1', description: '공부를 싫어하는 아이, 부모가 꼭 알아야 할 해결법', thumbnail: 'https://via.placeholder.com/80x80?text=13', rankChange: 0},
    14: {rank: 14, title: '스마트폰 중독 아이, 공부 습관 이렇게 바로잡자!', channel: 'ch1', description: '스마트폰 중독 아이, 공부 습관 이렇게 바로잡자!', thumbnail: 'https://via.placeholder.com/80x80?text=14', rankChange: 0},
    15: {rank: 15, title: '게임 중독 아이, 학습에 어떻게 유도할까?', channel: 'ch1', description: '게임 중독 아이, 학습에 어떻게 유도할까?', thumbnail: 'https://via.placeholder.com/80x80?text=15', rankChange: 0},
    16: {rank: 16, title: '아이의 공부 스트레스, 이렇게 풀어보세요!', channel: 'ch1', description: '아이의 공부 스트레스, 이렇게 풀어보세요!', thumbnail: 'https://via.placeholder.com/80x80?text=16', rankChange: 0},
    17: {rank: 17, title: '고교학점제 시리즈 ① 고교학점제란? 개념과 도입 배경 총정리', channel: 'ch1', description: '고교학점제 시리즈 ① 고교학점제란? 개념과 도입 배경 총정리', thumbnail: 'https://via.placeholder.com/80x80?text=17', rankChange: 0},
};

const StaticHtml = ({ number }: StaticHtmlProps) => {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        const response = await fetch(`/article/${number}.html`); // public/1.html 같은 형식
        if (!response.ok) {
          throw new Error(`HTML 파일을 불러올 수 없습니다: ${number}.html`);
        }
        const html = await response.text();
        setHtmlContent(html);
      } catch (error) {
        setHtmlContent('<p style="color:red;">HTML 파일을 불러오지 못했습니다.</p>');
      }
    };

    fetchHtml();
  }, [number]);

  const post = posts[number];

  return (
    <>
    
      <Helmet>
        <title>{`그루비 | ${post.title}`}</title>

        {/* ✅ 오직 한 번만 정의 */}
        <meta name="description" content={post.description} />
        
        {/* ✅ og 태그들도 각각 1번만 정의 */}
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.description} />
        <meta property="og:url" content={`https://groubee.kr/post/${number}`} />
        {/* <meta property="og:image" content={`https://groubee.kr/og-image.jpg`} />
        {/* 기타 필요한 meta 태그 */}
      </Helmet>
      <Container maxWidth="lg" sx={{ mt: 4, }}>
        {/* HTML 콘텐츠를 렌더링 */}
        {/* dangerouslySetInnerHTML 사용 시 XSS 공격에 주의해야 합니다. */}
        {/* 신뢰할 수 있는 HTML만 사용하세요. */}
          
          
        <Box
          sx={{  p: 2, mb: 14 }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </Container>
    </>
  );
};

export default StaticHtml;
